// frontend/src/components/BookReading/readingProgress.js
// Progresso de leitura por usuário (localStorage) + capa gerada por gradiente.
// Sem backend: usado pela Biblioteca (BookList) e pelo Sumário (ChapterList).

const READ_KEY = (u) => `readChapters_${u || 'anon'}`;
const LAST_KEY = (u) => `lastRead_${u || 'anon'}`;

// Conjunto de IDs de capítulos já lidos pelo usuário
export function getReadChapterIds(username) {
  try {
    const raw = localStorage.getItem(READ_KEY(username));
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.map(Number) : []);
  } catch (e) {
    return new Set();
  }
}

// Marca um capítulo como lido
export function markChapterRead(username, chapterId) {
  try {
    const set = getReadChapterIds(username);
    set.add(Number(chapterId));
    localStorage.setItem(READ_KEY(username), JSON.stringify([...set]));
  } catch (e) { /* ignora */ }
}

// Último capítulo lido (mesma estrutura gravada pelo ChapterReader)
export function getLastRead(username) {
  try {
    const raw = localStorage.getItem(LAST_KEY(username));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Progresso do livro = capítulos visíveis lidos / total de capítulos visíveis
export function bookProgress(book, readSet) {
  const visible = (book?.chapters || []).filter((c) => c.visible !== false);
  const total = visible.length;
  if (!total) return { read: 0, total: 0, pct: 0 };
  const read = visible.filter((c) => readSet.has(Number(c.id))).length;
  return { read, total, pct: Math.round((read / total) * 100) };
}

// Capa determinística por livro (sem imagem cadastrada) — paleta Biotrop
const GRADIENTS = [
  'linear-gradient(135deg, #00353d 0%, #144a50 100%)',
  'linear-gradient(135deg, #144a50 0%, #339288 100%)',
  'linear-gradient(135deg, #002328 0%, #00434d 100%)',
  'linear-gradient(135deg, #00353d 0%, #04d0c2 100%)',
  'linear-gradient(135deg, #173d42 0%, #3c8c71 100%)',
  'linear-gradient(135deg, #144a50 0%, #2aa44e 100%)',
];

export function coverGradient(book) {
  const seed = Number(book?.id) || (book?.title || '').length || 0;
  return GRADIENTS[seed % GRADIENTS.length];
}
